module.exports = __webpack_public_path__ + "static/media/mdi_plus-circle-dark.c6f73966.svg";